import { isSelfReferencingMenuUrl } from './isSelfReferencingMenuUrl';

export interface BenefitMenuItem {
  title: string;
  imageUrl?: string;
  description?: string;
  isNew: boolean;
  isPopular: boolean;
  //* url·placementKey는 하위 메뉴에서 둘 중 하나만 채워진다. url=이동, placementKey=외부 오퍼월 지면.
  url?: string;
  placementKey?: string;
}

export interface BenefitMenuGroup {
  title: string;
  items: BenefitMenuItem[];
}

//* 생성 타입을 직접 import하지 않고 구조적 최소 형태만 받는다 —
//* 필드가 리네임되면 useBenefitMenus의 호출이 컴파일에서 깨져 드리프트가 드러난다.
interface BenefitMenuApiShape {
  title: string;
  imageUrl?: string;
  description?: string;
  newYN: boolean;
  popularYN: boolean;
  url?: string;
  placementKey?: string;
  children?: BenefitMenuApiShape[];
}

/**
 * 최상위=그룹 헤더, children=실제 항목의 2단 응답을 그룹 배열로 정규화한다.
 * 현재 페이지로 그대로 돌아오는 항목은 눌러도 제자리인 무한루프가 되므로 걷어낸다
 * (출석 페이지의 '출석체크' 항목). 항목이 다 걸러진 그룹은 그룹째 빠진다.
 */
/**
 * 오퍼월(외부 지면) 항목을 가진 첫 그룹의 index.
 * 퀵액션의 '웰포인트 받기' 타일 노출 판정과 미션 섹션 앵커 부여가 공유한다 —
 * 판정이 갈리면 타일이 목적지 없는 죽은 클릭이 된다.
 */
export const findMissionGroupIndex = (groups: BenefitMenuGroup[]): number =>
  groups.findIndex((group) =>
    group.items.some((item) => !item.url && Boolean(item.placementKey)),
  );

export const resolveBenefitMenuGroups = (
  menus: BenefitMenuApiShape[],
  currentPathname: string,
): BenefitMenuGroup[] =>
  menus
    .map((group) => ({
      title: group.title,
      items: (group.children ?? [])
        .filter(
          (child) => !isSelfReferencingMenuUrl(child.url, currentPathname),
        )
        .map((child) => ({
          title: child.title,
          imageUrl: child.imageUrl,
          description: child.description,
          isNew: child.newYN,
          isPopular: child.popularYN,
          url: child.url,
          placementKey: child.placementKey,
        })),
    }))
    .filter((group) => group.items.length > 0);
